// @flow
const lego = window.lego

export const DEFAULT_IMAGE_RECT =
  'https://ucarecdn.com/337481dd-50cb-4948-8487-5d3d163aaf55/-/scale_crop/1200x630/'
export const DEFAULT_IMAGE_ICON = `${lego.config.ASSET_DOMAIN}/images/school/placeholder-thumb.png`
